import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "planTypeSelect", "feesSection"]
  static values = { objectName: String, subscriptionPlanTypeIds: Array }

  addFee(event) {
    event.preventDefault()

    const feeName = prompt('Enter fee name (lowercase letters, numbers, underscores only):\nExample: express_handling_fee')
    if (!feeName || feeName.trim() === '') {
      return
    }

    const sanitizedFeeName = this.sanitizeFeeName(feeName.trim())

    if (!this.isValidFeeName(sanitizedFeeName)) {
      alert('Invalid fee name!\n\nFee names must:\n- Contain only lowercase letters, numbers, and underscores\n- Not start or end with an underscore\n\nExample: express_handling_fee')
      return
    }

    const existingFee = this.containerTarget.querySelector(`[data-fee-key="${sanitizedFeeName}"]`)
    if (existingFee) {
      alert('A fee with this name already exists!')
      return
    }

    const objectName = this.objectNameValue
    const newFeeRow = document.createElement('div')
    newFeeRow.className = 'additional-fee-row mb-3'
    newFeeRow.setAttribute('data-fee-key', sanitizedFeeName)

    const checkboxId = `${objectName.replace(/[\[\]]/g, '_')}_additional_fees_${sanitizedFeeName}_recurring`

    newFeeRow.innerHTML = `
      <div class="d-flex gap-2 mb-2">
        <input class="form-control" type="text" value="${sanitizedFeeName}" placeholder="Fee name" style="flex: 2" readonly data-additional-fees-target="feeName">
        <input class="form-control" type="number" step="0.01" min="0.01" name="${objectName}[additional_fees][${sanitizedFeeName}][amount]" placeholder="Amount in USD" style="flex: 1" required>
        <div class="form-check d-flex align-items-center" style="min-width: 120px;">
          <input type="hidden" name="${objectName}[additional_fees][${sanitizedFeeName}][recurring]" value="false">
          <input class="form-check-input" type="checkbox" name="${objectName}[additional_fees][${sanitizedFeeName}][recurring]" value="true" id="${checkboxId}" data-additional-fees-target="recurring">
          <label class="form-check-label" for="${checkboxId}" style="margin-left: 0.25rem; font-size: 0.875rem;">Recurring</label>
        </div>
        <button class="btn btn-sm btn-danger" type="button" data-action="click->additional-fees#removeFee">Remove</button>
      </div>
      <textarea class="form-control form-control-sm" name="${objectName}[additional_fees][${sanitizedFeeName}][message]" placeholder="Customer message (optional, supports HTML: <strong>, <em>, <p>, <br>, <ul>, <li>, <a>)" rows="2" style="font-size: 0.875rem;"></textarea>
    `

    this.containerTarget.appendChild(newFeeRow)
  }

  removeFee(event) {
    event.preventDefault()
    const row = event.target.closest('.additional-fee-row')
    row.remove()
  }

  sanitizeFeeName(name) {
    return name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '')
  }

  isValidFeeName(name) {
    if (!/^[a-z0-9_]+$/.test(name)) {
      return false
    }

    if (name.startsWith('_') || name.endsWith('_')) {
      return false
    }

    return true
  }

  toggleVisibility(event) {
    if (!this.hasPlanTypeSelectTarget || !this.hasFeesSectionTarget) {
      console.warn('Additional fees: Missing planTypeSelect or feesSection target')
      return
    }

    const selectedPlanTypeId = parseInt(event.target.value)
    const isSubscriptionBox = this.subscriptionPlanTypeIdsValue.includes(selectedPlanTypeId)

    console.log('Additional fees toggle:', {
      selectedPlanTypeId,
      subscriptionPlanTypeIds: this.subscriptionPlanTypeIdsValue,
      isSubscriptionBox
    })

    if (isSubscriptionBox) {
      this.feesSectionTarget.style.display = ''
    } else {
      this.feesSectionTarget.style.display = 'none'
      this.clearAllFees()
    }
  }

  clearAllFees() {
    const feeRows = this.containerTarget.querySelectorAll('.additional-fee-row')
    feeRows.forEach(row => row.remove())
  }
}
